import { Card } from "react-bootstrap";
import parse from 'html-react-parser';
import log from "loglevel";
import 'styles/ckeditor-content.css'; // Unified CSS for WYSIWYG rendering
import { FiDownload } from "react-icons/fi";

const TopInfoBox = ({ otherActivityDetails, otherActivityData, activity_evaluated, showMarksToStudent }) => {

    // Check if file can be viewed in browser (images and PDFs)
    const canViewInBrowser = (fileUrl) => {
        if (!fileUrl) return false
        const ext = fileUrl.split('.').pop().toLowerCase()
        return ['pdf', 'png', 'jpg', 'jpeg', 'gif', 'svg', 'webp'].includes(ext)
    }

    let total_marks = 0;
    const seenQuestions3 = new Set();

    const getTotalMarks = () => {
        var student_marks = 0;
        let hasMarks = false;
        {
            otherActivityData?.question_set?.filter(activity => {
                const isDuplicate = seenQuestions3.has(activity.question_id);
                seenQuestions3.add(activity.question_id);
                return !isDuplicate;
            }).map((activity, index) => {
                if (activity?.marks) {
                    total_marks = total_marks + activity?.marks;
                    const scoredMarks = activity?.questionresponse_set?.scored_marks;
                    if (scoredMarks !== undefined && scoredMarks !== null) {
                        student_marks = student_marks + scoredMarks;
                        hasMarks = true;
                    }
                    // log.log("total_marks ", total_marks, activity?.marks)
                }
            })
        }
        // log.log("total_marks", total_marks);
        // Show student marks if they have marks available and the setting allows it
        if (hasMarks && showMarksToStudent) {
            return `${student_marks} / ${total_marks}`
        }
        return total_marks;
    }

    return (
        <Card className="text-center" style={{
            // marginTop: "20px",
            // padding: "10px",
            border: "1px solid #ddd"
        }}>
            {/* <Card.Header style={{ backgroundColor: "#f7f7f7" }}></Card.Header> */}
            <Card.Body style={{ backgroundColor: "#f0f3f8" }}>
                {otherActivityDetails?.lab_data?.title ?
                    <Card.Title style={{ fontSize: "1.5rem", fontWeight: "bold", marginBottom: "10px" }}>
                        {otherActivityDetails.lab_data?.title}
                    </Card.Title> : <></>
                }
                <Card.Text style={{ fontSize: "1rem", marginBottom: "20px" }}>
                    <span style={{ fontWeight: "bold", fontSize: 40, color: 'rgb(41, 121, 255)' }}>{otherActivityData?.name}</span><br />
                    <span style={{ fontWeight: "bold", fonSize: 8, color: 'black' }}>Total Marks: {getTotalMarks()}</span>
                </Card.Text>
                <div style={{ textAlign: "left", marginTop: "10px", paddingLeft: "1rem", paddingRight: "1rem" }} className="activity-description ck-content">
                    {otherActivityData?.description && typeof otherActivityData.description === 'string' ? parse(otherActivityData.description) : null}
                </div>
                {otherActivityData?.extra_files && (
                    <div style={{ textAlign: "left", marginTop: "15px", paddingLeft: "1rem", paddingRight: "1rem" }}>
                        <a
                            href={otherActivityData.extra_files}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "8px",
                                padding: "8px 16px",
                                backgroundColor: "#e8f4fd",
                                border: "1px solid #2979ff",
                                borderRadius: "6px",
                                color: "#2979ff",
                                textDecoration: "none",
                                fontWeight: "500",
                                cursor: "pointer"
                            }}
                        >
                            <FiDownload size={18} />
                            {canViewInBrowser(otherActivityData.extra_files) ? "View Additional Files" : "Download Additional Files"}
                        </a>
                    </div>
                )}
            </Card.Body>
        </Card>
    )
}

export default TopInfoBox;